import ptBRTemplate from 'app/freshchat/ptBR-pre-chat-template'
import enUSTemplate from 'app/freshchat/enUS-pre-chat-template'
import esESTemplate from 'app/freshchat/esES-pre-chat-template'
import i18n from 'app/i18n'
import theme from 'app/theme'
import Cookies from 'js-cookie'

import freshChatService from 'services/fresh-chat'
import { parseBoolean } from 'app/utils'

const isSSOEnabled = () => {
  const isSSO = Cookies.get('isSSO')
  return parseBoolean(isSSO)
}

const getFreshChatCredentials = async () => {
  const hasSSO = isSSOEnabled()

  const currentAuthApi = hasSSO ? 'authentication-sso' : 'authentication'

  const { ok, data } = await freshChatService.getCredentials(currentAuthApi)
  if (ok && data) {
    return data
  }

  return false
}

const getTemplateByLanguage = {
  'pt-BR': ptBRTemplate,
  'en-US': enUSTemplate,
  'es-ES': esESTemplate
}

let freshChatInitialized = false
export const loadFreshChatWidget = async () => {
  const credentials = await getFreshChatCredentials()

  if (!freshChatInitialized) {
    freshChatInitialized = true

    if (credentials) {
      const fcPreChatform = document.createElement('script')
      fcPreChatform.type = 'text/javascript'
      fcPreChatform.defer = true
      fcPreChatform.async = true
      fcPreChatform.src = 'https://snippets.freshchat.com/js/fc-pre-chat-form-v2.js'
      document.body.appendChild(fcPreChatform)

      const preChatTemplate = getTemplateByLanguage[i18n.language]

      const formattedPrechatTemplate = {
        mainbgColor: theme.palette.primary.main,
        ...preChatTemplate
      }

      const onInitPreChat = () => window.fcPreChatform.fcWidgetInit(formattedPrechatTemplate)
      const cssNames = {
        widget: 'fc_frame',
        expanded: 'fc_expanded'
      }

      if (!window.fcSettings) {
        window.fcSettings = {
          token: credentials.token,
          host: credentials.host,
          onInit: onInitPreChat,
          config: {
            cssNames,
            headerProperty: {
              hideChatButton: true
            }
          }
        }
      }

      const fcWidget = document.createElement('script')
      fcWidget.type = 'text/javascript'
      fcWidget.defer = true
      fcWidget.async = true
      fcWidget.src = 'https://wchat.freshchat.com/js/widget.js'
      document.body.appendChild(fcWidget)
    }
  }
}

export default {
  loadFreshChatWidget
}
